import { spp } from '../viewSettings/settingsProps/settingsAll'

export const addPropItem = (viewItem, viewProps, propKey, propDataOpt) => {
  viewProps[propKey] = spp(propKey, propDataOpt)
  viewProps[propKey].propSection = propKey
  if (viewItem) {
    viewItem.propSections[propKey] = {
      key: propKey,
      position: Object.keys(viewItem.propSections).length,
      show: true,
      showDesktop: true,
    }
  }
}
